import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

// (min-width: 769px) reproduces the shell's long-standing `window.innerWidth > 768`
// desktop/mobile split. Single source of truth for NavDrawerComponent/AppComponent,
// replacing the raw `window.innerWidth` polling in `ngDoCheck` that left a dead zone
// between the drawer's 768px threshold and Bootstrap's 576px `.d-sm-none` cutoff.
const DESKTOP_QUERY = '(min-width: 769px)';

@Injectable({
  providedIn: 'root',
})
export class ShellBreakpointService {
  readonly isDesktop$: Observable<boolean> = this.breakpointObserver.observe(DESKTOP_QUERY).pipe(
    map(state => state.matches),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor(private breakpointObserver: BreakpointObserver) {}

  get isDesktopNow(): boolean {
    return this.breakpointObserver.isMatched(DESKTOP_QUERY);
  }
}
